import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/v1/worklines',
    name: 'PUT_WORK_LINES',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
